import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { OfferingSummary } from './pages/OfferingSummary';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsAndConditions } from './pages/TermsAndConditions';
import { BlinqCard } from './pages/BlinqCard';
import { LogoOptions } from './pages/LogoOptions';
import { WordmarkOptions } from './pages/WordmarkOptions';
import { WordmarkOptions2 } from './pages/WordmarkOptions2';
import { WordmarkOptions3 } from './pages/WordmarkOptions3';
import { ScandiLogos } from './pages/ScandiLogos';
export function AppRouter() {
  return <BrowserRouter data-id="element-8">
      <Routes data-id="element-9">
        <Route path="/" element={<App data-id="element-11" />} data-id="element-10" />
        <Route path="/offerings" element={<OfferingSummary data-id="element-13" />} data-id="element-12" />
        <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-15" />} data-id="element-14" />
        <Route path="/terms-and-conditions" element={<TermsAndConditions data-id="element-17" />} data-id="element-16" />
        <Route path="/blinq-card" element={<BlinqCard data-id="element-19" />} data-id="element-18" />
        <Route path="/logo-options" element={<LogoOptions data-id="element-21" />} data-id="element-20" />
        <Route path="/wordmarks" element={<WordmarkOptions data-id="element-23" />} data-id="element-22" />
        <Route path="/wordmarks-2" element={<WordmarkOptions2 data-id="element-25" />} data-id="element-24" />
        <Route path="/wordmarks-3" element={<WordmarkOptions3 data-id="element-27" />} data-id="element-26" />
        <Route path="/scandi-logos" element={<ScandiLogos data-id="element-29" />} data-id="element-28" />
      </Routes>
    </BrowserRouter>;
}